import React from 'react';
import parse from 'html-react-parser';
import csharp from 'react-syntax-highlighter/dist/esm/languages/hljs/csharp';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/light';
import CodeBlock from '../components/reader/CodeBlock';

// Register C# language for fallback
SyntaxHighlighter.registerLanguage('csharp', csharp);

/**
 * Wrap consecutive HTML-based C#- und Generic-Snippet-Container
 * in `<pre data-codegroup="...">…</pre>`.
 */
export function wrapCodeGroups(html) {
    const genericGroup = /<div[^>]*class="codeSnippetContainerCode"[^>]*>\s*<pre[^>]*>([\s\S]*?)<\/pre>\s*<\/div>/g;
    const csGroup      = /((?:(?:<p class="(?:bodytext|listcontinue1)">\s*<span class="stcode(?:\s+\w+)*">)[\s\S]*?<\/span>\s*<\/p>\s*)+)/g;
    const csLine       = /<p class="(?:bodytext|listcontinue1)">\s*<span class="stcode(?:\s+\w+)*">([\s\S]*?)<\/span>\s*<\/p>/g;

    return html
        // Generic container → C#
        .replace(genericGroup, (_, code) => {
            const lines = code
                .split(/\r?\n/)
                .map(line => line.replace(/<span[^>]*>([\s\S]*?)<\/span>/g, '$1').trim())
                .filter(l => l.length > 0);
            return `<pre data-codegroup="csharp">${lines.join('\n')}</pre>`;
        })
        // HTML-C#
        .replace(csGroup, all => {
            const lines = Array.from(all.matchAll(csLine)).map(m => m[1].replace(/<[^>]+>/g, '').trim());
            return `<pre data-codegroup="csharp">${lines.join('\n')}</pre>`;
        });
}

/** C# indent basierend auf geschweiften Klammern */
function indentCSharp(code) {
    const lines = code.split('\n'); let lvl = 0;
    return lines.map(raw => {
        const t = raw.trim();
        if (/^\}/.test(t)) lvl = Math.max(lvl - 1, 0);
        const ind = '  '.repeat(lvl) + t;
        if (/\{$/.test(t)) lvl++;
        return ind;
    }).join('\n');
}

/**
 * Parse HTML → wrapCodeGroups → replace <pre data-codegroup> mit CodeBlock
 */
export function transformCodeBlocks(html) {
    const wrapped = wrapCodeGroups(html);

    return parse(wrapped, {
        replace: domNode => {
            if (domNode.name === 'pre' && domNode.attribs?.['data-codegroup'] === 'csharp') {
                const raw = domNode.children
                    .filter(c => c.type === 'text')
                    .map(c => c.data)
                    .join('');
                const code = indentCSharp(raw);
                return <CodeBlock language="csharp" value={code} />;
            }
            return undefined;
        }
    });
}
